<template>
  <section class="catalog-grid no-gutters c-sm:c-justify-center c-md:c-justify-start c-flex-col c-mt-2 c-md:c-mt-3 c-lg:c-mt-4 catalog__grid">
    <template v-if="isLoaded">
      <template
        v-for="(item, index) in combinedArray"
        :key="index"
      >
        <ProductBanner
          v-if="Array.isArray(item)"
          :data="item"
        />
        <ProductItem
          v-else
          class="catalog-grid-item"
          :product="item"
          :status="cardStatus"
          :lazy-load="index > 2"
          :info-click-behaviour="infoClickBehaviour"
          :is-search-page="isSearchPage"
        />
      </template>
    </template>
    <template v-else>
      <article
        v-for="index in 3"
        :key="index"
        class="catalog-grid-item product-item relative flex c-flex-col c-flex-grow-1 c-p-4 c-sm:c-p-3 c-md:c-p-4 w-100"
      >
        <div class="c-mb-4">
          <PlaceholderLoader
            class="block c-rounded"
            style="padding-bottom: 75%;"
          />
        </div>
        <PlaceholderLoader
          class="c-mb-2 c-rounded"
          style="height: 24px; width: 130px;"
        />
        <PlaceholderLoader
          class="c-mb-2 c-rounded"
          style="height: 22px; width: 70%;"
        />
        <PlaceholderLoader
          class="c-rounded"
          style="height: 63px; width: 70%;"
        />
        <div class="c-pt-3 c-xl:c-pt-4 c-pb-2">
          <PlaceholderLoader
            class="c-rounded"
            style="height: 35px;"
          />
        </div>
        <PlaceholderLoader
          class="form-row c-mt-auto c-rounded c-mx-0"
          style="height: 66px;"
        />
      </article>
    </template>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import PlaceholderLoader from '@/components/general/BasePlaceholderLoader.vue'
import ProductItem from '@/components/products/ProductsCatalogGridItem.vue'
import ProductBanner from '@/components/products/ProductsCatalogGridBanner.vue'

const props = defineProps({
  products: {
    type: Array,
    required: true,
  },

  banners: {
    type: Array,
    required: true,
  },

  infoClickBehaviour: {
    type: String,
    default: 'modal',
  },

  isLoaded: {
    type: Boolean,
    required: true,
  },

  cardStatus: {
    type: String,
    default: 'default'
  },

  isSearchPage: {
    type: Boolean,
    default: false,
  }
});

const bannerPositions = [2, 6, 13, 18];

const combinedArray = computed(() => {
  const tempArray = [...props.products]
  if (props.banners) {
    tempArray.forEach((item, index) => {
      const positionBanners = props.banners[bannerPositions.indexOf(index)];
      if (bannerPositions.includes(index) && positionBanners.length) {
        tempArray.splice(index, 0, positionBanners);
      }
    });
  }

  return tempArray
})
</script>